import * as React from 'react';
import { SubscribeEmail } from '../../components/SubscribeEmail';
import { useDeviceType } from '@cian/ui-kit';
import { useTimeout } from '../../../common/utils/useTimeout/useTimeout';
import { useApplicationContext } from '../../../common/utils/applicationContext';
import { useToggleState } from '@cian/react-utils';

import { ESubscribeStatus } from '../../../common/types/subscribe';
import { fetchSubscribe } from '../../services/fetchSubscribe';

export const SubscribeEmailContainer: React.FC = () => {
  const isMobile = useDeviceType() === 'phone';

  const inputRef = React.useRef<HTMLInputElement | null>(null);

  const timeout = useTimeout();

  const context = useApplicationContext();

  const { state: loading, toggle: toggleLoading } = useToggleState(false);

  const [status, setStatus] = React.useState<ESubscribeStatus>(ESubscribeStatus.Initial);
  const [message, setMessage] = React.useState('');

  const closeInfo = () => {
    setStatus(ESubscribeStatus.Initial);
  };

  const sendEmail = React.useCallback(async () => {
    const uri = window.location.pathname;

    toggleLoading();

    if (inputRef.current && uri) {
      const res = await fetchSubscribe(context, { email: inputRef.current.value, source: uri });

      toggleLoading();

      setStatus(res.statusCode === 200 ? ESubscribeStatus.Succeed : ESubscribeStatus.Failed);
      setMessage(res.message);

      timeout.current = setTimeout(closeInfo, 4000);
    }
  }, [context, timeout, toggleLoading]);

  return (
    <SubscribeEmail
      onClose={closeInfo}
      onSendMail={sendEmail}
      isMobileDevice={isMobile}
      refInput={inputRef}
      isLoading={loading}
      fetchMessage={message}
      statusSendMail={status}
    />
  );
};
